// do that import because it polyfills window.setImmediate somehow which is required by BrowserConsole
import 'vuejs-dialog';

import { logger } from '@anschuetz-elog/common';

logger.configure();

export default logger;
